module.exports = {
        srcSet: __webpack_public_path__ + "destination_host_rewe-138-eb5dbdeaf21dd48a.digested.jpg"+" 138w",
        images: [{path: __webpack_public_path__ + "destination_host_rewe-138-eb5dbdeaf21dd48a.digested.jpg",width: 138,height: 48}],
        src: __webpack_public_path__ + "destination_host_rewe-138-eb5dbdeaf21dd48a.digested.jpg",
        toString: function(){return __webpack_public_path__ + "destination_host_rewe-138-eb5dbdeaf21dd48a.digested.jpg"},
        
        width: 138,
        height: 48
      }